"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Button = _interopRequireDefault(require("../../Button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PriceFilterSegments = function PriceFilterSegments(_ref) {
  var _ref$segments = _ref.segments,
    segments = _ref$segments === void 0 ? [] : _ref$segments,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 0 : _ref$max,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? Function.prototype : _ref$onClick,
    _ref$onSegmentHovered = _ref.onSegmentHovered,
    onSegmentHovered = _ref$onSegmentHovered === void 0 ? Function.prototype : _ref$onSegmentHovered,
    className = _ref.className,
    selectedId = _ref.selectedId;
  var heightK = (0, _react.useMemo)(function () {
    return 100 / Math.max.apply(Math, (0, _toConsumableArray2["default"])(segments.map(function (col) {
      return col.percent;
    })));
  }, [segments]);
  var handleMouseLeave = function handleMouseLeave(e) {
    e.preventDefault();
    onSegmentHovered(null);
  };
  if (!(segments !== null && segments !== void 0 && segments.length)) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledDistributionContainer, {
    className: className
  }, segments.map(function (segment) {
    var id = segment.id,
      to = segment.to,
      from = segment.from,
      percent = segment.percent;
    return /*#__PURE__*/_react["default"].createElement(PriceSegment, {
      key: id,
      "aria-label": "\u041E\u0442 ".concat(min, " \u0434\u043E ").concat(max),
      height: percent * heightK,
      selected: selectedId && selectedId === id,
      disabled: from > max || to < min || percent === 0,
      onClick: function onClick() {
        return _onClick(segment);
      },
      onMouseEnter: function onMouseEnter() {
        return onSegmentHovered(segment);
      },
      onMouseLeave: handleMouseLeave
    });
  }));
};
var StyledDistributionContainer = _styledComponents["default"].div.withConfig({
  displayName: "PriceFilterSegments__StyledDistributionContainer",
  componentId: "sc-qjz0iy-0"
})(["display:flex;height:100%;align-items:flex-end;flex-wrap:nowrap;"]);
var PriceSegment = (0, _styledComponents["default"])(_Button["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "PriceFilterSegments__PriceSegment",
  componentId: "sc-qjz0iy-1"
})(["height:", ";position:relative;flex-grow:1;flex-shrink:0;outline:none;min-width:0;&:not(:last-child){border-right:2px solid transparent;}", " ", " &:after{content:'';width:100%;height:100%;position:absolute;left:0;bottom:0;background:", ";box-sizing:border-box;transform:scaleY(-1);", " ", "}"], function (_ref2) {
  var height = _ref2.height;
  return "".concat(height, "%");
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && (0, _styledComponents.css)(["pointer-events:none;"]);
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return !disabled && (0, _styledComponents.css)(["&:hover:after{", ";}"], function (_ref5) {
    var theme = _ref5.theme;
    return theme.gradient.darkBlueToLight();
  });
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.frenchGray;
}, function (_ref7) {
  var selected = _ref7.selected,
    theme = _ref7.theme;
  return selected && (0, _styledComponents.css)(["", ";"], theme.gradient.darkBlueToLight());
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled && (0, _styledComponents.css)(["background:none;border:solid 1px ", ";"], function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.frenchGray;
  });
});
var _default = exports["default"] = PriceFilterSegments;